<template>
    <div>
        <div style="background-color: #f6fcff; margin: 10px auto; padding: 20px auto">
            <span class="endereco" v-if="filialOrigemLocalidade">
                <i class="fa fa-building" style="margin-right: 10px"></i>
                CD ORIGEM: {{ filialOrigemLocalidade }}
            </span>
        </div>
        <div style="background-color: #f6fcff; margin: 10px auto; padding: 20px auto">
            <div>
                <span class="endereco" v-if="endereco">
                    <i class="fa fa-map-marker" style="margin-right: 10px"></i>
                    DESTINO: {{ endereco }}
                </span>

                <div class="transportadora-container">
                    <Loader v-if="loading" style="margin: 25px auto 10px auto" />

                    <div v-if="transportadorasComEndereco">
                        <div class="selecao-transportadora"
                             v-for="transportadora in transportadorasComEndereco.Transportadoras"
                             :key="transportadora.DadosTransportadora.Codigo">
                            <div class="radio-container">
                                <label :for="`radio-transportadora-${transportadora.DadosTransportadora.Codigo}`">
                                    <input type="radio"
                                           :id="`radio-transportadora-${transportadora.DadosTransportadora.Codigo}`"
                                           name="radio"
                                           :value="transportadora.DadosTransportadora.Codigo"
                                           v-model="shippingSelected"
                                           @change="setTranportadoraSubTotal(transportadora.DadosTransportadora)" />
                                    <div class="custom-radio">
                                        <span></span>
                                    </div>
                                </label>
                            </div>

                            <div class="transportadora" v-on:click="setTranportadoraSubTotal(transportadora.DadosTransportadora, true)">
                                <div class="transportadora-nome">
                                    <div style="font-weight: 600; color: #365db5">
                                        {{ transportadora.DadosTransportadora.RazaoSocial }}
                                    </div>
                                </div>
                                <div class="transportadora-valores">
                                    <div style="font-size: 15px; font-weight: 600; white-space: nowrap">{{ transportadora.DadosFrete.frete }} *</div>
                                    <div style="white-space: nowrap">{{ transportadora.DadosFrete.prazoCalculado }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="loadValorRepasse">
            <div class="col-md-12">
                <div class="row">
                    <div class="text-right" :class="{ 'col-md-8': !personalizacao, 'col-md-10': personalizacao }">
                        {{ personalizacao ? 'Total produtos' : 'Valor Produto' }}:
                    </div>
                    <div class="text-right" :class="{ 'col-md-4': !personalizacao, 'col-md-2': personalizacao }">{{ formatCurrency(totalProduto) }}</div>
                </div>
                <div class="row">
                    <div class="text-right" :class="{ 'col-md-8': !personalizacao, 'col-md-10': personalizacao }">Quantidade:</div>
                    <div class="text-right" :class="{ 'col-md-4': !personalizacao, 'col-md-2': personalizacao }">{{ qtdeProduto }}</div>
                </div>
                <div v-if="!personalizacao" class="row">
                    <div class="col-md-12">&nbsp;</div>
                </div>
                <div v-if="!personalizacao" class="row">
                    <div class="text-right" :class="{ 'col-md-8': !personalizacao, 'col-md-10': personalizacao }">Total Produtos:</div>
                    <div class="text-right" :class="{ 'col-md-4': !personalizacao, 'col-md-2': personalizacao }">
                        {{ formatCurrency(totalProduto * qtdeProduto) }}
                    </div>
                </div>
                <div v-if="valorRepasse !== 'R$ 0,00' && valorRepasse !== 0">
                    <div class="row">
                        <div class="text-right" :class="{ 'col-md-8': !personalizacao, 'col-md-10': personalizacao }">Total Repasse:</div>
                        <div class="text-right" :class="{ 'col-md-4': !personalizacao, 'col-md-2': personalizacao }">
                            {{ formatCurrency(valorRepasse * qtdeProduto) }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="text-right" :class="{ 'col-md-8': !personalizacao, 'col-md-10': personalizacao }">Produtos + Repasse:</div>
                        <div class="text-right" :class="{ 'col-md-4': !personalizacao, 'col-md-2': personalizacao }">
                            {{ formatCurrency(calcularTotalProduto(totalProduto, valorRepasse, 0, qtdeProduto)) }}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="text-right" :class="{ 'col-md-8': !personalizacao, 'col-md-10': personalizacao }">Valor Frete:</div>
                    <div class="text-right" :class="{ 'col-md-4': !personalizacao, 'col-md-2': personalizacao }">{{ formatCurrency(valorFrete) }}</div>
                </div>
                <div class="row">
                    <div class="col-md-12">&nbsp;</div>
                </div>
                <div v-if="valorRepasse !== 'R$ 0,00' && valorRepasse !== 0">
                    <div class="row">
                        <div class="col-md-12 text-right">
                            <label style="text-align: left; font-weight: bold; font-size: 15px"> Valor Total (Produto + Repasse + Frete) </label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 text-right">
                            <label style="font-size: 22px; font-weight: bold">
                                {{
                formatCurrency(calcularTotalProduto(totalProduto, valorRepasse, valorFrete, qtdeProduto))
                                }}
                            </label>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="row">
                        <div class="col-md-12 text-right">
                            <label style="text-align: left; font-weight: bold; font-size: 15px"> Valor Total (Produto + Frete) </label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 text-right">
                            <label style="font-size: 22px; font-weight: bold">
                                {{
                formatCurrency(calcularTotalProduto(this.totalProduto, 0, valorFrete, qtdeProduto))
                                }}
                            </label>
                        </div>
                    </div>
                </div>
                <div class="row">&nbsp;</div>
                <div class="row">
                    <label style="font-size: 13px; font-weight: bold; color: red">
                        * Os valores de frete podem variar no momento do fechamento do pedido, especialmente para entregas em regiões rurais.
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'ProductShippingDetails',
  props: {
    cep: { type: String, default: '' },
    totalProduto: { type: Number, default: 0 },
    peso: { type: Number, default: 0 },
    codigoProduto: { type: String, default: '0' },
    qtdeProduto: { type: Number, default: 0 },
    codigoCliente: { type: Number, default: 0 },
    habilitaSelecao: { type: Boolean, default: false },
    valorRepasse: { type: Number, default: 0 },
    personalizacao: { type: Boolean, default: false },
    isGerador: { type: Boolean, default: true },
    isBateria: { type: Boolean, default: false },
  },

        data() {
            return {
                loading: false,
                totalProdutoInput: 0,
                loadValorRepasse: false,
                shippingSelected: 0,
                valorFrete: 0,
                valorFreteSelecionado: 0,
                transportadorasComEndereco: null,
                moneyConfig: {
                    decimal: ',',
                    thousands: '.',
                    prefix: 'R$ ',
                    precision: 2,
                    masked: false,
                },
                resumeClass: ['col-md-8 text-right', 'col-md-4 text-right'],
                filialOrigemLocalidade: null
            }
        },

        mounted() {
            if (this.personalizacao) {
                this.resumeClass = ['col-md-10 text-right', 'col-md-2 text-right']
            }
        },

        methods: {
            formatCurrency: function (v) {
                //formada coluna de valores da tabela para moeda
                const formato = {
                    minimumFractionDigits: 2,
                    style: 'currency',
                    currency: 'BRL',
                }

                return parseFloat(v).toLocaleString('pt-BR', formato)
            },

            setTranportadoraSubTotal(transportadora, setarModel = false) {
                if (!transportadora) {
                    this.valorFreteSelecionado = 0
                    this.valorFrete = 0
                    this.shippingSelected = 0
                    return
                }

                if (setarModel) this.shippingSelected = transportadora.Codigo

                this.valorFreteSelecionado = 0
                this.valorFreteSelecionado = transportadora.Taxa + this.totalProduto
                this.valorFrete = transportadora.Taxa
                this.loadValorRepasse = true
            },

            calculaFrete: function (prd_codigo_painel, limparSelecao = false) {
                const self = this
                self.loading = true
                self.loadValorRepasse = false

                if (limparSelecao) {
                    self.setTranportadoraSubTotal(null)
                }

                self.transportadorasComEndereco = null
                self.filialOrigemLocalidade = null;
                const xhr = new XMLHttpRequest()
                xhr.onload = () => {
                    if (xhr.status == 200) {
                        if (xhr.responseText != '' && xhr.responseText != null) {
                            let json = JSON.parse(xhr.responseText)
                            let loadValorRepasse = true
                            if (!json.Endereco) {
                                json.Endereco = {
                                    cep: self.cep,
                                    city: `Endereço com o CEP: ${self.cep} não encontrado!`,
                                    neighborhood: '',
                                    service: '',
                                    state: '',
                                    street: '',
                                }
                                loadValorRepasse = false
                            }

                            if (json.FilialOrigemLocalidade)
                                self.filialOrigemLocalidade = json.FilialOrigemLocalidade

                            self.transportadorasComEndereco = json
                            self.loadValorRepasse = loadValorRepasse
                            self.loading = false
                        }
                    }
                }
                xhr.open('POST', self.$apiUrl + 'Transportadora.svc/loadcifproduto')
                xhr.setRequestHeader('Content-Type', 'application/json')
                xhr.withCredentials = true
                const codigoProduto = self.codigoProduto.split('-')[0]
                xhr.send(
                    JSON.stringify({
                        totalProduto: self.totalProduto * self.qtdeProduto,
                        valorRepasse: self.valorRepasse * self.qtdeProduto,
                        totalPeso: self.peso,
                        cli_codigo: self.codigoCliente,
                        CEP: self.cep,
                        prd_codigo_painel: prd_codigo_painel,
                        gerador: self.isGerador,
                        prd_codigo: codigoProduto,
                        bateria: self.isBateria,
                        personalizacao: this.personalizacao
                    })
                )
            },

            fechar: function () {
                $('#product-shipping-details-modal').modal('hide')
            },

            calcularTotalProduto: function (valorProduto, valorRepasse, valorFrete, qtdeProduto) {
                const valorProdutos = !this.personalizacao ? valorProduto * qtdeProduto : valorProduto

                const total = valorProdutos + valorRepasse * qtdeProduto + valorFrete

                return total
            },

            formataEndereco: function (endereco) {
                const cityState = endereco.city || endereco.state ? `${endereco.city} - ${endereco.state}` : ''
                return endereco.city.includes('Endereço com o CEP: ') ? endereco.city : cityState
            },
        },

        computed: {
            endereco: function () {
                return this.transportadorasComEndereco != null ? this.formataEndereco(this.transportadorasComEndereco.Endereco) : ''
            },
        },
    }
</script>

<style type="text/css" scoped>
    .modal-header {
        background: #365db5;
        color: white;
    }

        .modal-header .header {
            display: flex;
            justify-content: space-between;
        }

        .modal-header .close {
            color: white;
            opacity: 1;
        }

    .inputs {
        margin: 10px 10px 11px;
        display: flex;
        flex-direction: column;
    }

        .inputs .form-group {
            margin-bottom: 2px;
        }

        .inputs .cep {
            display: flex;
            gap: 10px;
            align-items: center;
        }

    input[type='radio'] {
        display: none;
    }

    .radio-container label {
        display: flex;
        align-items: center;
        column-gap: 20px;
    }

    .custom-radio {
        border: 1px solid #037cc2;
        width: 25px;
        height: 25px;
        display: grid;
        place-content: center;
        border-radius: 50%;
        cursor: pointer;
    }

    .custom-radio,
    span {
        transition: 0.5s ease;
        color: #fff;
    }

        .custom-radio span {
            content: '';
            width: 15px;
            height: 15px;
            background: #fff;
            border-radius: 50%;
            border: 1px solid #037cc2;
        }

    input[type='radio']:checked + .custom-radio {
        border-color: rgb(54, 93, 181);
    }

        input[type='radio']:checked + .custom-radio span {
            background: rgb(54, 93, 181);
        }

    .max-width {
        width: 100%;
    }

    .transportadora-container {
        display: flex;
        flex-direction: column;
        gap: 20px;
        text-align: center;
    }

    .selecao-transportadora {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .transportadora {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 5px 10px;
        gap: 10px;
        width: 100%;
        cursor: pointer;
    }

        .transportadora:nth-child(odd) {
            background-color: #d8f1fe;
        }

    .transportadora-nome {
        display: flex;
        flex-direction: column;
        text-align: left;
    }

    .transportadora-valores {
        display: flex;
        flex-direction: column;
        text-align: right;
        font-size: 13px;
        gap: 4px;
    }

    .product-title span {
        font-size: 14px;
    }

    .modal-title {
        font-size: 22px;
    }

    .actions {
        display: flex;
        justify-content: end;
        margin-top: 16px;
    }

    .endereco {
        color: rgb(54, 93, 181);
        padding-bottom: 0px;
        padding-left: 4px;
        font-size: 13px;
        text-align: left;
        font-weight: 400;
        margin-bottom: 10px;
        display: block;
        background: #ecf8ff;
        padding: 10px 20px;
    }

    @media (max-width: 600px) {
        .modal-title {
            font-size: 16px;
        }

        .product-title {
            font-size: 15px;
        }

        .actions {
            flex-direction: column;
        }
    }
</style>
